import { Typography } from "@mui/material";
import { Box, List, ListItem, ListItemText } from "@mui/material";
import cleaningIcon from "../Assets/cleaning supplies2.png";

export default function CleaningSolutions() {
  const products = [
    "Dishwashing Liquid",
    "Bleach ",
    "Ammoniated Handy Cleaner",
    "Floor Polymer",
    "Degreaser",
    "Pine Gel",
    "Deo / Urinal Blocks",
    "Pink Hand Soap",
  ];
  return (
    <Box sx={{ textAlign: "center" }}>
      <img
        src={cleaningIcon}
        alt="Cleaning Supplies Icon"
        style={{ height: 70, marginBottom: 16 }}
      />
      <Typography variant="h5" fontWeight="bold" gutterBottom color="#ffcc00ff">
        Range of Cleaning Products
      </Typography>
      {/* <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        Our pack sizes typically range from 500g to 25Kg or 500ml to 25L
        variants. We can also produce customised pack sizes.
      </Typography> */}
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          ml: 5,
          mt: 4,
        }}
      >
        {products.map((product, idx) => (
          <ListItem
            key={idx}
            disablePadding
            sx={{ width: "auto", justifyContent: "center" }}
          >
            <ListItemText primary={`• ${product}`} sx={{ textAlign: "left" }} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
